import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';
import Select from 'react-select';

class CapacityContractTypeSelector extends Component {
  render() {
    const { t, onChange, placeholder, value } = this.props;
    const options = [
      {
        value: 'permanentContract',
        label: t('capacityContractType.permanentContract'),
      },
      {
        value: 'transportOrderContract',
        label: t('capacityContractType.orderContract'),
      },
      {
        value: 'oneTimeContract',
        label: t('capacityContractType.oneTimeContract'),
      },
    ];
    return (
      <Select
        value={options.find((option) => option.value === value)}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
        noOptionsMessage={() => t('noOptions')}
      />
    );
  }
}

export default withTranslation('translation')(CapacityContractTypeSelector);
